// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";

// i18n
//   .use(initReactI18next)
//   .use(LanguageDetector)
//   .init({
//     lng: localStorage.getItem("language") || "de", // Default language
//     fallbackLng: "en",
//     interpolation: { escapeValue: false },
//   });

// export default i18n;

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend"; // 👈 add this

i18n
  .use(HttpBackend) // 👈 enable backend to load JSON files
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: localStorage.getItem("language") || "de",

    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // 👈 where to find translations
    },

    interpolation: { escapeValue: false },
    react: { useSuspense: false }, // optional: helps avoid loading issues
  });

export default i18n;
